import React from 'react'

const LoadingScreen = () => (
  <div className="center-progress-display">
    <i className="fa fa-spinner fa-spin"></i>
  </div>
)

export default LoadingScreen
